/**
 * @file: AiTrialPill.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { formatAiCredits } from '@euler/app/components/ai/overlay/functions/formatAiCredits';
import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { aiColors, tint } from '../theme';
import { AiTrialCredits } from './useAiTrialCredits';

/**
 * `试用中 · 剩余积分：…` under the AI home's title: `light` on the blue
 * header, `dark` once the bar turns white.
 */
export const AiTrialPill = memo(
  ({ trial, tone }: { trial: AiTrialCredits; tone: 'light' | 'dark' }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          marginTop: rpx(2),
          // Below the title, not competing with it.
          opacity: 0.75,
          paddingHorizontal: rpx(8),
          paddingVertical: rpx(1),
          borderRadius: rpx(999),
          backgroundColor:
            tone === 'light'
              ? 'rgba(255,255,255,0.18)'
              : tint(aiColors.primary, 0.1),
        }}
      >
        <Typography.Text
          medium
          size={rpx(10)}
          color={
            tone === 'light' ? aiColors.primaryForeground : aiColors.primary
          }
          numberOfLines={1}
        >
          试用中
          {trial.credits != null
            ? ` · 剩余积分：${formatAiCredits(trial.credits)}`
            : ''}
        </Typography.Text>
      </View>
    );
  },
);
